module.exports = __webpack_public_path__ + "static/media/TwitterLogo.7d7f4594.png";


//////////////////
// WEBPACK FOOTER
// ./src/TwitterLogo.png
// module id = 249
// module chunks = 0